const experiences = [
  {
    title: 'Software Engineer Intern | Coinbase',
    description: [`Software Engineer Intern at Coinbase for the summer.`],
    skills: [],
    image: require('../../images/experiences/coinbase-logo-icon.png'),
  },
  {
    title: 'Graduate Software Engineer | Visa',
    incoming: true,
    description: [`Joining Visa as a Graduate Software Engineer.`],
    skills: [],
    image: require('../../images/experiences/visa-logo.png'),
  },
  {
    title: 'Software Engineer Intern | Eutelsat',
    description: [
      `Designed and implemented a serverless architecture featuring a multi-layered caching system (API Gateway, Lambda, DynamoDB), successfully reducing monthly operational costs by over £2,000.`,
      `Engineered multiple end-to-end data pipelines to ingest, validate, and store data in PostGIS and S3, and optimized a core Lambda function to achieve a 90% improvement in execution speed.`,
      `Strengthened code quality by authoring comprehensive unit and integration tests with pytest and embedding them into the CI/CD workflow for automated validation and regression testing.`,
    ],
    skills: ['Python', 'AWS', 'CI/CD', 'PostGIS', 'Pytest', 'SQL'],
    image: require('../../images/experiences/eutelsat.jpeg'),
  },
  {
    title: 'Software Developer Intern | Ghyston',
    description: [
      `Worked on React on front end and Dotnet on back end`,
      `Designed and migrated the data in the backend when implementing new features`,
      `Improved the user experience by designing and creating a clean and responsive front-end`,
    ],
    skills: ['Typescript', 'React', 'C#'],
    image: require('../../images/experiences/ghyston.jpeg'),
  },
];

export default experiences;
